import { authFetch } from "~/services/fetch";

// ! GRÁFICO DE PIZZA

export async function getOccurrencesAssociatedAnimalBySpecie({
  startDate,
  finishDate,
  specieId,
  destinationId,
  circunstanceId,
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-animal-by-specie',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        specie_id: specieId,
        destination_id: destinationId,
        circunstance_id: circunstanceId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedAnimalByCircunstance({
  startDate,
  finishDate,
  specieId,
  destinationId,
  circunstanceId,
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-animal-by-circunstance',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        specie_id: specieId,
        destination_id: destinationId,
        circunstance_id: circunstanceId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedAnimalByDestination({
  startDate,
  finishDate,
  specieId,
  destinationId,
  circunstanceId,
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-animal-by-destination',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        specie_id: specieId,
        destination_id: destinationId,
        circunstance_id: circunstanceId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedAnimalByOccurrenceType({
  startDate,
  finishDate,
  specieId,
  destinationId,
  circunstanceId,
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-animal-by-occurrence-type',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        specie_id: specieId,
        destination_id: destinationId,
        circunstance_id: circunstanceId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}


